module.exports = __webpack_public_path__ + "static/img/logo03.be88623.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/protectplus_britapro_com/images/logo03.png
// module id = 1842
// module chunks = 0